import {
  Page,
  Document,
  PDFViewer,
  Image,
  View,
  Text,
  StyleSheet,
} from "@react-pdf/renderer";
import dayjs from "dayjs";
import "dayjs/locale/es";

const s = StyleSheet.create({
  page: {
    padding: "50px 65px 0 60px",
    fontFamily: "Helvetica",
    fontSize: 10,
  },
  bold: { fontFamily: "Helvetica-Bold" },
  italic: { fontFamily: "Helvetica-Oblique" },
  row: { display: "flex", flexDirection: "row", gap: 0 },
  col: { display: "flex", flexDirection: "column", gap: 0 },
  header: {
    position: "absolute",
    top: -1.2,
    right: "20px",
    zIndex: -10,
  },
  styleFormat: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: -10,
    width: "612px",
    height: "792px",
  },
  cell: { paddingHorizontal: 3, paddingVertical: 2 },
  bLeft: { borderLeftWidth: 1 },
  bRight: { borderRightWidth: 1 },
  bBottom: { borderBottomWidth: 1 },
  bTop: { borderTopWidth: 1 },
  bAll: { borderWidth: 1 },
  txtCenter: { textAlign: "center" },
  border: { borderWidth: 1 },
  styleFormat: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: -10,
    width: "612px",
    height: "792px",
  },
  w10: { width: "10%" },
  w20: { width: "20%" },
  w30: { width: "30%" },
  w40: { width: "40%" },
  w45: { width: "45%" },
  w50: { width: "50%" },
  w55: { width: "55%" },
  w60: { width: "60%" },
  w70: { width: "70%" },
  w80: { width: "80%" },
  w90: { width: "90%" },
  wfull: { width: "100%" },
});

export const GenerateReceptionPDF = (props) => {
  const { item, onClose, data } = props;
  dayjs.locale("es");

  const MyDoc = () => {
    const numeros = require("numeros_a_palabras");

    numeros.numero2word().Config._setSingular("BOLIVIANO");
    numeros.numero2word().Config._setPlural("BOLIVIANOS");
    numeros.numero2word().Config._setCentsSingular("CENTAVO");
    numeros.numero2word().Config._setCentsPlural("CENTAVOS");

    const CellText = ({ children, style = [] }) => {
      const combinedStyle = Array.isArray(style) ? style : [];

      return <Text style={[s.cell, ...combinedStyle]}>{children}</Text>;
    };

    return (
      <Document>
        <Page size="LETTER" style={s.page}>
          {/* FORMATO */}
          <View style={s.styleFormat}>
            <Image
              src="https://res.cloudinary.com/joeldes/image/upload/v1751556894/DeliveryDay/reports/DD_formato-informe_xdmzwo.jpg"
              style={{ width: "100%", height: "100%" }}
            />
          </View>

          <View style={s.bAll}>
            <View style={s.row}>
              <View
                style={[
                  s.w50,
                  s.col,
                  {
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 9,
                  },
                ]}
              >
                <Image
                  style={{ height: "150px" }}
                  source="https://res.cloudinary.com/joeldes/image/upload/v1751556893/DeliveryDay/reports/DD_Logo_Color_etwlg1.png"
                />
                {data.procCity === "LP" ? (
                  <>
                    <Text>CASA MATRIZ - 0</Text>
                    <Text>Av. 6 de marzo, edif. Bella Vista No. 554</Text>
                    <Text>Piso 4 of. 4B esquina Cruce Viacha</Text>
                    <Text>Tel.:(591 2) 2591904 Cel.: (591)78823331</Text>
                    <Text>e-mail: info@ddaysrl.com</Text>
                    <Text>La Paz - Bolivia</Text>
                    <Text>SFC-1</Text>
                  </>
                ) : data.procCity === "SC" ? (
                  <>
                    <Text>SANTA CRUZ - SUCURSAL 1</Text>
                    <Text>ENTRE CALLE JUAN CARRILLO Y ARMANDO PALACIOS,</Text>
                    <Text> NRO: 6270 BARRIO OXIBOL,</Text>
                    <Text>UV .122 MZA.12 DISTRITO 9, SEXTO ANILLO</Text>
                    <Text>, ZONA SUR, SANTA CRUZ.</Text>
                    <Text>Tel.:(3)3727365 Cel.: (591)78164941</Text>
                    <Text>e-mail: info@ddaysrl.com</Text>
                    <Text>Santa Cruz - Bolivia</Text>
                    {/* <Text>SFC-1</Text> */}
                  </>
                ) : data.procCity === "OR" ? (
                  <>
                    <Text>ORURO - SUCURSAL 2</Text>
                    <Text>OTRO MANZANO 12, NRO. 8,</Text>
                    <Text>URBANIZACION AMPLIACION SAN ISIDRO,</Text>
                    <Text style={{ textAlign: "center" }}>
                      CASA DE LA ESQUINA, PARALELO AVENIDA 24 DE JUNIO, ALTURA
                      COMPLEJO VINTO, ORURO.
                    </Text>
                    <Text>Cel.: (591)60123563</Text>
                    <Text>e-mail: info@ddaysrl.com</Text>
                    <Text>Oruro - Bolivia</Text>
                    {/* <Text>SFC-1</Text> */}
                  </>
                ) : null}
              </View>
              <View
                style={[
                  s.w50,
                  s.col,
                  s.txtCenter,
                  { alignItems: "center", justifyContent: "center" },
                ]}
              >
                <View
                  style={[
                    s.w70,
                    {
                      backgroundColor: "black",
                      color: "white",
                      padding: "10 15",
                      borderColor: "#E1DFDF",
                      borderWidth: 2,
                      borderRadius: 2,
                    },
                  ]}
                >
                  <Text style={{ fontSize: 13 }}>RECIBO OFICIAL</Text>
                </View>
                <View style={[s.col, s.w70, { alignItems: "center" }]}>
                  <CellText style={[{ fontSize: 12 }]}>ORIGINAL</CellText>
                  <CellText style={[{ fontSize: 8 }]}>
                    AGENCIA DESPACHANTE DE ADUANA
                  </CellText>
                </View>
                <View
                  style={[
                    s.w70,
                    { backgroundColor: "#bfbfbf", padding: "5 15" },
                  ]}
                >
                  <Text style={{ fontSize: 11 }}>
                    {data.numeroDeFactura ?? "-"}
                  </Text>
                </View>
              </View>
            </View>

            <Text
              style={[
                s.w90,
                {
                  marginHorizontal: "auto",
                  height: "1px",
                  backgroundColor: "black",
                  marginVertical: ".5cm",
                },
              ]}
            ></Text>

            <View style={{ paddingTop: ".6cm", paddingBottom: "1cm" }}>
              <View style={[s.row, { height: "1.5cm" }]}>
                <CellText>
                  Recibí del Señor(a): {data.company.razonSocial}
                </CellText>
              </View>
              <View style={[s.row, { height: "1.5cm" }]}>
                <CellText style={[s.w50]}>
                  Fecha:{" "}
                  {dayjs(item.creationDate).format("D [de] MMMM [del] YYYY")}
                </CellText>
                <CellText style={[s.w50]}>Bs.: {item.description}</CellText>
              </View>
              <View style={{ height: "1.5cm" }}>
                <CellText>Por concepto de: {item.label}</CellText>
              </View>
              <View style={{ height: "1.5cm" }}>
                <CellText>
                  La suma de:{" "}
                  {numeros.numero2word(Number(item.description)).toString()}
                </CellText>
              </View>
              <View style={{ height: "1.5cm" }}>
                <CellText>
                  Nº Documento: {data.a1NúmeroDeDeclaración ?? "-"}
                </CellText>
              </View>
            </View>

            {/* Firmas */}
            <View
              style={[
                s.row,
                {
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "3cm",
                  paddingBottom: "2cm",
                },
              ]}
            >
              <View style={[s.col, { alignItems: "center" }]}>
                <Text>___________________________</Text>
                <Text style={{ paddingTop: 6 }}>Entregue conforme </Text>
                <Text>Cliente: …………………...</Text>
              </View>
              <View style={[s.col, { alignItems: "center" }]}>
                <Text>___________________________</Text>
                <Text style={{ paddingTop: 6 }}>Recibí conforme</Text>
                <Text>DELIVERYDAY S.R.L.</Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    );
  };

  return (
    <div>
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
      >
        <MyDoc />
      </PDFViewer>
    </div>
  );
};
